import { PropsWithChildren } from 'react'

import { StyledContainer as S } from './Container.styles'

type Props = PropsWithChildren<{ className?: string }>

export const Container = ({ children, className = '' }: Props) => (
  <S.Root className={className}>{children}</S.Root>
)
